import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e38952fa"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e38952fa&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e38952fa')) {
      api.createRecord('e38952fa', component.options)
    } else {
      api.reload('e38952fa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e38952fa", function () {
      api.rerender('e38952fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/automaticSortings/sortingMachineScanRecord/index.vue"
export default component.exports